export default __webpack_public_path__ + "static/farm-d7beda16c643cb1e40dfecd41956ee2d.mp4";